import { isNil, isString } from 'es-toolkit';

/**
 * Returns true when the value is null, undefined, or a string that contains only
 * whitespace (or is empty). Non-string values other than null/undefined are
 * considered non-blank.
 */
export function isBlank(value: unknown): boolean {
  if (isNil(value)) return true;
  if (!isString(value)) return false;
  return value.trim().length === 0;
}
